// Module
var code = "<div class=\"navbar-form navbar-right\" ng-transclude> </div>";
// Exports
module.exports = code;